(()=>{

  /**
   * Tab Panel 切り替え
   *
   */

  const tabPanel = document.querySelectorAll('.js-panel');
  const tabBtn = document.querySelectorAll('.js-tabbtn');
  const panels = document.querySelectorAll('.contact-tabpanel__panel');

  tabBtn.forEach((item) => {
    item.addEventListener('click', (e) => {
      e.preventDefault();

      console.log('clicked')

      const target = item.getAttribute('aria-controls');
      const targetPanel = document.querySelector(`#${target}`);

      tabBtn.forEach((btn) => {
        btn.classList.remove('is-active');
      });
      panels.forEach((panel) => {
        panel.classList.remove('is-active');
      });

      item.classList.add('is-active');
      targetPanel.classList.add('is-active');
    });
  });

})();
